module.exports = __webpack_public_path__ + "img/edit.dbead4b9.svg";